import { render } from "./ImageItem.vue?vue&type=template&id=0d852f7d&scoped=true"
import script from "./ImageItem.vue?vue&type=script&lang=js"
export * from "./ImageItem.vue?vue&type=script&lang=js"

import "./ImageItem.vue?vue&type=style&index=0&id=0d852f7d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d852f7d"]])

export default __exports__